import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useContext(AuthContext);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Main>{children}</Main>;
};

export default PrivateRoute;
